<ng-container *ngIf="!cashGenerate; else loading">
	<h1 mat-dialog-title class="d-flex justify-content-between py-3">
		Płatność
		<i (click)="closeDialog()" class="fas fa-close cursor-pointer"></i>
	</h1>

	<section mat-dialog-content class="d-flex flex-column py-2">
		<mat-form-field appearance="outline">
			<mat-label>Rodzaj</mat-label>
			<mat-select
				required
				[(ngModel)]="data.kind.id"
				ngDefaultControl
				(ngModelChange)="onPaymentKindChange($event)"
			>
				<mat-option [value]="paymentKind.id" *ngFor="let paymentKind of paymentKinds">
					{{ paymentKind.description }}
				</mat-option>
			</mat-select>
		</mat-form-field>
		<mat-radio-group
			aria-label="Wybierz jedno"
			[(ngModel)]="isOrganization"
			ngDefaultControl
			(change)="switchPayerType()"
		>
			<mat-radio-button [value]="false">Osoba fizyczna</mat-radio-button>
			<mat-radio-button [value]="true">Organizacja</mat-radio-button>
		</mat-radio-group>

		<mat-form-field appearance="outline">
			<mat-label>Kto wpłaca</mat-label>
			<ng-container *ngIf="isOrganization">
				<input
					type="text"
					placeholder="Wybierz jedno"
					matInput
					required
					[formControl]="organizationsSelect"
					[matAutocomplete]="auto"
				/>

				<mat-autocomplete
					#auto="matAutocomplete"
					[displayWith]="displayFn.bind(this)"
					(optionSelected)="changeOrganization($event)"
				>
					<mat-option *ngFor="let org of filteredOrganizations" [value]="org.id">{{ org.name }}</mat-option>
				</mat-autocomplete>
			</ng-container>
			<ng-container *ngIf="!isOrganization">
				<input
					type="text"
					[formControl]="usersSelect"
					placeholder="Wybierz jedno"
					matInput
					required
					[matAutocomplete]="auto"
				/>
				<mat-autocomplete
					#auto="matAutocomplete"
					(optionSelected)="changeUser($event)"
					[displayWith]="displayUserFn.bind(this)"
				>
					<mat-option *ngFor="let user of filteredUsers" [value]="user"
						>{{ user.firstName }} {{ user.lastName }} | {{ user?.birth | date: 'dd.MM.yyyy' }} |
						{{ user.userContacts[0]?.phone }}</mat-option
					>
				</mat-autocomplete>
			</ng-container>
			<mat-hint
				align="end"
				(click)="openUserDataDialog()"
				class="text-primary cursor-pointer hover-underline quick-add"
			>
				Szybkie dodawanie
			</mat-hint>
		</mat-form-field>
		<mat-form-field appearance="outline">
			<mat-label>Kwota</mat-label>
			<input
				type="number"
				required
				matInput
				[ngModel]="data.amount ? (data.amount | price) : null"
				(ngModelChange)="data.amount = convertToGrosze($event)"
			/>
		</mat-form-field>
		<!-- Hidden for now -->
		<!--	<mat-form-field appearance="outline">-->
		<!--		<mat-label>Waluta</mat-label>-->
		<!--		<mat-select required disabled [(ngModel)]="data.currency">-->
		<!--			<mat-option-->
		<!--				[value]="currency.id"-->
		<!--				*ngFor="let currency of currencies"-->
		<!--				>{{ currency.code }}</mat-option-->
		<!--			>-->
		<!--		</mat-select>-->
		<!--	</mat-form-field>-->
		<div class="row">
			<div class="col">
				<mat-form-field appearance="outline">
					<mat-label>Data wpłaty</mat-label>
					<input matInput [matDatepicker]="datepickerA" required [(ngModel)]="data.payment" />
					<mat-datepicker-toggle matSuffix [for]="datepickerA"></mat-datepicker-toggle>
					<mat-datepicker #datepickerA>
						<mat-datepicker-actions>
							<button mat-button matDatepickerCancel>Anuluj</button>
							<button mat-raised-button color="primary" matDatepickerApply>Zatwierdź</button>
						</mat-datepicker-actions>
					</mat-datepicker>
				</mat-form-field>
			</div>
			<div class="col">
				<mat-form-field appearance="outline">
					<mat-label>Data zaksięgowania</mat-label>
					<input matInput [matDatepicker]="datepicker" required [(ngModel)]="data.posting" />
					<mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
					<mat-datepicker #datepicker>
						<mat-datepicker-actions>
							<button mat-button matDatepickerCancel>Anuluj</button>
							<button mat-raised-button color="primary" matDatepickerApply>Zatwierdź</button>
						</mat-datepicker-actions>
					</mat-datepicker>
				</mat-form-field>
			</div>
		</div>
		<mat-form-field appearance="outline" *ngIf="!isCashSelected" class="bankAccountPostingInput">
			<mat-label>Konto Oskar</mat-label>
			<mat-select [(ngModel)]="data.bankAccountPosting">
				<ng-container>
					<mat-option [value]="account.id" *ngFor="let account of incomingBankAccounts">
						{{ account.shortName }} {{ account.number }}
					</mat-option>
				</ng-container>
			</mat-select>
		</mat-form-field>
		<mat-form-field appearance="outline" *ngIf="!isCashSelected" class="bankAccountIncomingInput">
			<mat-label>Konto Klient</mat-label>
			<input #clientAccount [(ngModel)]="data.bankAccountIncoming" matInput type="text" maxlength="50" />
			<mat-hint align="end">{{ clientAccount.value?.length }} / 50</mat-hint>
		</mat-form-field>
		<mat-form-field appearance="outline">
			<mat-label>Numer FV</mat-label>
			<input [(ngModel)]="data.invoiceNumber" matInput type="text" />
		</mat-form-field>
		<mat-form-field appearance="outline">
			<mat-label>Uwagi</mat-label>
			<textarea [(ngModel)]="data.note" matInput></textarea>
		</mat-form-field>
	</section>

	<mat-dialog-actions>
		<button mat-raised-button color="primary" (click)="submit()">Zapisz</button>
	</mat-dialog-actions>
</ng-container>
<ng-template #loading>
	<div class="d-flex flex-column align-items-center">
		<mat-spinner></mat-spinner>
		<p class="mt-4">Generowanie potwierdzenia wpłaty<br />Proszę czekać...</p>
	</div>
</ng-template>
